export const VIEWER_PROBE_TIMEOUT_MS = 3500;

/**
 * Reachability check for the viewer web origin (:5081 in dev).
 *
 * `no-cors` so production cross-origin embeds still tell us "TCP reached
 * something" vs "connection refused". A compile that is still running
 * accepts the socket and is `ok`; only a dead port is `unreachable`.
 *
 * @returns {{ ok: boolean, reason: "missing" | "reached" | "timeout" | "unreachable" }}
 */
export async function probeViewerOrigin(
  origin,
  timeoutMs = VIEWER_PROBE_TIMEOUT_MS,
) {
  if (!origin) return { ok: false, reason: "missing" };
  const ctrl = new AbortController();
  const tid = window.setTimeout(() => ctrl.abort(), timeoutMs);
  try {
    await fetch(`${String(origin).replace(/\/$/, "")}/`, {
      method: "GET",
      mode: "no-cors",
      cache: "no-store",
      signal: ctrl.signal,
    });
    return { ok: true, reason: "reached" };
  } catch (err) {
    const aborted = err?.name === "AbortError";
    return { ok: false, reason: aborted ? "timeout" : "unreachable" };
  } finally {
    window.clearTimeout(tid);
  }
}
